import { gql } from "@apollo/client";

export const FIND_CART = gql`
	query FindCart($customerToken: String!, $status: CartStatusTypes!) {
		carts(
			condition: { customerToken: $customerToken, status: $status }
			first: 1
		) {
			nodes {
				id
				checkoutId
				cartItems {
					nodes {
						id
						productId
						quantity
						variantId
						product {
							name
							imageSrc
						}
						variant {
							name
							price
							weight {
								value
								units
							}
						}
					}
				}
			}
		}
	}
`;

export const CREATE_CART = gql`
	mutation CreateCart($cart: CartInput!) {
		createCart(input: { cart: $cart }) {
			cart {
				id
			}
		}
	}
`;

export const ADD_CART_ITEM = gql`
	mutation AddCartItem($cartItem: CartItemInput!) {
		createCartItem(input: { cartItem: $cartItem }) {
			cartItem {
				id
			}
		}
	}
`;

export const UPDATE_CART_ITEM = gql`
	mutation updateCartItem($cartItem: UpdateCartItemInput!) {
		updateCartItem(input: $cartItem) {
			clientMutationId
		}
	}
`;

export const REMOVE_CART_ITEM = gql`
	mutation DelateCartItem($cartItemId: UUID!) {
		deleteCartItem(input: { id: $cartItemId }) {
			clientMutationId
		}
	}
`;

export const GET_CART_ITEMS = gql`
	query GetCartItems($cartId: UUID!) {
		cartItems(condition: { cartId: $cartId }) {
			nodes {
				id
				productId
				quantity
				variantId
				product {
					name
					imageSrc
				}
				variant {
					name
					price
				}
			}
		}
	}
`;
